import { apiRequest } from "@/lib/queryClient";
import { uploadFileToObjectStorage } from "@/lib/object-storage-upload";

/**
 * Uploads an image picked/pasted/dropped in a note to object storage and
 * registers it in the media library (which claims the upload reservation
 * server-side), returning the served URL to embed in the note.
 *
 * Keeps note images out of the database — no base64 data URLs.
 */
export async function uploadNoteImage(file: File): Promise<string> {
  const fileUrl = await uploadFileToObjectStorage(file);
  await apiRequest("POST", "/api/media", {
    name: file.name || "pasted-image",
    fileName: file.name || "pasted-image",
    fileUrl,
    fileType: file.type.split("/")[1] || "unknown",
    fileSize: file.size,
    category: "notes",
    tags: [],
  });
  return fileUrl;
}
